import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Per-route SEO helper. Sets unique <title>, meta description, canonical URL,
 * and Open Graph / Twitter Card tags so each public route is indexed correctly
 * by Google, Bing, and AI crawlers.
 *
 * Usage:
 *   <Seo
 *     title="Sign Up | Thirrsty"
 *     description="Create a free Thirrsty profile…"
 *     path="/auth/signup"
 *   />
 */

const SITE_URL = 'https://thirrsty.com';
const SITE_NAME = 'Thirrsty.com';
const DEFAULT_IMAGE = `${SITE_URL}/logo-hero.png`;

export function Seo({
  title,
  description,
  path = '/',
  image = DEFAULT_IMAGE,
  noindex = false,
  type = 'website',
}) {
  const url = `${SITE_URL}${path}`;
  const fullTitle = title || 'Thirrsty.com — Your VIP Pass to the Night';

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}

export default Seo;
